
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Pipe({
  name: 'curlData'
})

export class CurlDataPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) {

  }
  transform(data: any) {

    var index = 1;
    var result = data;
    do {

      result = result.replace("-num-", index);

      index++;
    } while (result.indexOf("-num-") >= 0);

    return result;
  }
}
